import { useQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { GET_ONE_PROCESS_REQUEST_BY_ID } from '../../../graphql/Catalog/Processes/Requests/ProcessesRequests'
import { toastSweetAlert } from '../../Helpers/ToastSweetAlert'
import Loader from '../../Global/Spinner'
import Box from '../../Global/Box'
import ContentHeader from '../../Layout/ContentHeader'
import InternalNotesRequest from '../../Global/InternalNotes/InternalNotesRequest'
import ProgressBarStatusRequest from '../../Global/ProgressBarStatusRequest'

const ProcessesRequestsNew = () => {
  const { id: _id } = useParams()

  const [dataRequest, setDataRequest] = useState(null)

  const { loading, error, data } = useQuery(GET_ONE_PROCESS_REQUEST_BY_ID, {
    variables: {
      getProcessRequestByIdId: +_id,
    },
    fetchPolicy: 'no-cache',
  })

  useEffect(() => {
    try {
      if (loading) return
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      setDataRequest(data.getProcessRequestById)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, loading, error])

  return (
    <>
      <ContentHeader
        title="Solicitud de trámite"
        windowTitle="Solicitud de trámite"
        breadcrumb=""
      />
      {loading || !dataRequest ? (
        <div className="d-flex justify-content-center align-items-center">
          <Loader />
        </div>
      ) : (
        <>
          <Box
            title={<>Detalles trámite</>}
            content={
              <>
                <div className="row">
                  <div className="col-lg-6">
                    <h5>
                      Nombre: {dataRequest.ProcessesRequestsToProcesses.name}
                    </h5>
                  </div>
                  <div className="col-lg-6">
                    <h5>
                      Tipo:{' '}
                      {
                        dataRequest.ProcessesRequestsToProcesses
                          .ProcessesToProcessesTypes.name
                      }
                    </h5>
                  </div>
                  <div className="col-lg-6">
                    <h5>
                      Departamento:{' '}
                      {dataRequest.ProcessesRequestsToDepartments.name}
                    </h5>
                  </div>
                  <div className="col-lg-6">
                    <h5>
                      Estatus:
                      <ProgressBarStatusRequest
                        keyStatusRequest={
                          dataRequest.ProcessesRequestsToStatus.key
                        }
                      />
                    </h5>
                  </div>
                </div>
              </>
            }
          />

          <Box
            title="Datos del ciudadano"
            content={
              <>
                <div className="row mt-3">
                  <div className="col-lg-6">
                    <h5>
                      Ciudadano:{' '}
                      {`${dataRequest.ProcessesRequestsToCitizens.name} ${dataRequest.ProcessesRequestsToCitizens.last_name}`}
                    </h5>
                  </div>
                  <div className="col-lg-6">
                    <h5>
                      Email: {dataRequest.ProcessesRequestsToCitizens.email}
                    </h5>
                  </div>
                  <div className="col-lg-6">
                    <h5>
                      Teléfono: {dataRequest.ProcessesRequestsToCitizens.phone}
                    </h5>
                  </div>
                  <div className="col-lg-6">
                    <h5>
                      Dirección:{' '}
                      {dataRequest.ProcessesRequestsToCitizens.address || 'S/A'}
                    </h5>
                  </div>
                  <div className="col-lg-6">
                    <h5>
                      Ciudad:{' '}
                      {dataRequest.ProcessesRequestsToCitizens.city || 'S/A'}
                    </h5>
                  </div>
                  <div className="col-lg-6">
                    <h5>
                      Estado:{' '}
                      {dataRequest.ProcessesRequestsToCitizens.state || 'S/A'}
                    </h5>
                  </div>
                  <div className="col-lg-6">
                    <h5>
                      Código postal:{' '}
                      {dataRequest.ProcessesRequestsToCitizens.zip_code ||
                        'S/A'}
                    </h5>
                  </div>
                  <div className="col-lg-6">
                    <h5>
                      Colonia:{' '}
                      {dataRequest.ProcessesRequestsToCitizens.colony || 'S/A'}
                    </h5>
                  </div>
                </div>
              </>
            }
          />

          <div className="row">
            {' '}
            <div className="col-lg-6">
              <Box
                title="Archivos adjuntos"
                content={
                  <>
                    <div className="row">
                      {dataRequest &&
                      dataRequest.ProcessesRequestToAttachments.length > 0 ? (
                        <div className="d-flex flex-wrap" style={{ gap: 10 }}>
                          {dataRequest.ProcessesRequestToAttachments?.map(
                            (attachment) => {
                              if (!attachment?.url) {
                                return null
                              }

                              return (
                                <div
                                  key={attachment.id}
                                  className="btn btn-light"
                                >
                                  <a
                                    className="link-primary documentLink"
                                    style={{ textDecoration: 'none' }}
                                    as="button"
                                    href={attachment.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Descargar"
                                  >
                                    {attachment.type_file === 'pdf'
                                      ? 'PDF'
                                      : attachment.type_file === 'png'
                                      ? 'IMG'
                                      : attachment.type_file === 'jpg'
                                      ? 'IMG'
                                      : attachment.type_file === 'jpeg'
                                      ? 'IMG'
                                      : 'DESCARGAR'}
                                    <i
                                      className={`fas fa-file-${
                                        attachment.type_file === 'pdf'
                                          ? 'pdf'
                                          : attachment.type_file === 'png'
                                          ? 'image'
                                          : attachment.type_file === 'jpg'
                                          ? 'image'
                                          : attachment.type_file === 'jpeg'
                                          ? 'image'
                                          : 'download'
                                      } fa-2x ml-2`}
                                    ></i>
                                  </a>
                                </div>
                              )
                            }
                          )}
                        </div>
                      ) : (
                        <>
                          <div className="col-lg-12">
                            <h5>No hay archivos adjuntos</h5>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                }
              />
            </div>
            <div className="col-lg-6">
              <InternalNotesRequest
                request_id={dataRequest.id}
                category_note={'request'}
                flagSwitchInternalMode={false}
              />
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default ProcessesRequestsNew
